import { render, staticRenderFns } from "./DGNDDBaoCaoGanDay.vue?vue&type=template&id=5b3cf738&scoped=true"
import script from "./DGNDDBaoCaoGanDay.vue?vue&type=script&lang=ts"
export * from "./DGNDDBaoCaoGanDay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3cf738",
  null
  
)

export default component.exports